import $ from 'jquery';

var Checkbox = {
    selectors: {
        checkbox: $('.checkbox-input'),
        checkbox_hover: $('.checkbox-label'),
        products_list_container: $('.products__content-products-wrapper')
    },

    init: function () {
        this.eventHandler();
    },

    eventHandler: function () {
        var selectors = this.selectors;

        selectors.checkbox.change(function () {
            Checkbox.checkboxHandler(this);
        });
    },

    checkboxHandler: function (checkbox) {
        if (!$(checkbox).hasClass('checkbox-input-compare')) {
            $(checkbox).parents('.checkbox-label').toggleClass('checkbox-checked');
        }
    }
}

export default Checkbox;
